import { defineComponent as _defineComponent } from 'vue'
import { emptyList } from '@/services/api';
  import { CoursesList } from '@/entities/trainings';
  import FilterForm from '@/ui/components/filters/horizontal/FilterForm.vue';
  import SearchFilter from '@/ui/components/filters/horizontal/SearchFilter.vue';
  import { ref, watch } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { Loader } from '@/ui/components/Loader';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { Pagination } from '@/ui/components/Pagination';
  import { list as listCourses } from '@/services/api/resources/trainings';
  import { usePagination, useTask } from '@/ui/concerns';
  import * as qs from '@/ui/queryState';
  import { debounce } from 'lodash';
  import StartCourseModal from '@/ui/components/trainings/courseTake/StartCourseModal.vue';
  import { useStartCourseModal } from '@/ui/concerns/trainings/useStartCourseModal';
  import TakeCourseEmpty from '@/ui/pages/trainings/tabs/empty/TakeCourseEmpty.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TakeCourseTab',
  setup(__props) {

  const coursesList = ref<CoursesList>(emptyList());
  const search = qs.string('q', '');
  const { page, perPage, resetPagination } = usePagination();

  const getCourses = useTask(
    () => listCourses({
      page: page.value,
      perPage: perPage.value,
      search: search.value,
    }),
    result => {
      coursesList.value = result;
    },
  );

  watch([page, perPage, search], debounce(() => {
    getCourses.run();
  }, 100));

  const { isStartModalOpen, closeStartModal, confirmStartCourse, courseToStart, openStartCourse } = useStartCourseModal();

return { __sfc: true,coursesList, search, page, perPage, resetPagination, getCourses, isStartModalOpen, closeStartModal, confirmStartCourse, courseToStart, openStartCourse, FilterForm, SearchFilter, Box, Loader, ResourceTable, Pagination, StartCourseModal, TakeCourseEmpty }
}

})